module.exports = __webpack_public_path__ + "static/media/search-m.0dc775b5.svg";